'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  DECIMAL: 'decimal',
  CURRENCY: 'currency',
  PERCENTAGE: 'percentage'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.233/js/constants/NumberTypes.js
// module id = 291
// module chunks = 0